import { create } from "zustand";

const useAllPermissionsStore = create((set) => ({
  permissions: [],
  loading: false,
  error: null,

  fetchPermissions: async () => {
    set({ loading: true, error: null });
    try {
      const accessToken = localStorage.getItem("accessToken");
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/permissions`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          redirect: "follow",
        }
      );

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      set({ permissions: data.data, loading: false });
      // console.log("All Permissions Data", data.data)
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
}));

export default useAllPermissionsStore;
